<template>
    <!-- 次卡 -->	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
				<el-form-item>
					<el-input v-model="filters.name"  @keyup.enter.native="getFrequencyCard" placeholder="项目名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="getFrequencyCard" icon="el-icon-search">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">添加套餐项目</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="FrequencyCard" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<!-- <el-table-column type="Id" width="0">
			</el-table-column> -->
			<el-table-column prop="Name" label="套餐名称" width="200" sortable>
			</el-table-column>
			<el-table-column prop="Frequency" label="套餐次数" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Money" label="套餐金额" width="120" sortable>
			</el-table-column>	
			<el-table-column prop="Count" label="时限(N月)" width="120" sortable>
			</el-table-column>	
			<el-table-column prop="Remind" label="提醒次数" width="120" sortable>
			</el-table-column>		
			<!-- <el-table-column prop="FinalTime" label="最终日期" width="120" sortable :formatter="formatFinalTime">
			</el-table-column>						 -->
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
			<el-table-column prop="State" label="套餐状态" width="120" sortable fixed="right">				  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="info" size="medium" v-if="scope.row.State==1">停用</el-tag>
                  <el-tag type="success" size="medium" v-else>启用</el-tag>
                  </div>
                  </template>
			</el-table-column>
			<el-table-column  label="变更状态" width="120" sortable fixed="right">
				<template slot-scope="scope">			
				<el-switch :ref="FrequencyCard[scope.$index].Id"   v-model="FrequencyCard[scope.$index].BoolState" active-color="#13ce66" inactive-color="#ff4949" @click.native.stop="SwitchChange(scope.row)" :disabled="false"></el-switch>
				 </template>
			</el-table-column>
			<el-table-column  label="上线开关" width="120" sortable fixed="right">
				<template slot-scope="scope">			
				<el-switch :ref="FrequencyCard[scope.$index].Id"   v-model="FrequencyCard[scope.$index].IsShow" active-color="#13ce66" inactive-color="#ff4949" @change="Change(scope.row.IsShow,FrequencyCard[scope.$index].Id)" :disabled="false"></el-switch>
				 </template>
			</el-table-column>
			<el-table-column label="操作" width="140" fixed="right">
				<template  slot-scope="scope">
					<el-button size="small" @click="open(scope.row.Id)">延期</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
				
				<el-form-item label="套餐名称" prop="Name">
					<el-input v-model="editForm.Name" auto-complete="off"></el-input>
				</el-form-item>
					<el-form-item label="套餐次数" prop="Frequency">
					<el-input v-model="editForm.Frequency" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input type="textarea" v-model="editForm.Remark"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--新增界面-->
		<el-dialog title="新增套餐" v-model="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
				<el-form-item label="套餐名称" prop="Name">
					<el-input v-model="addForm.Name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="套餐次数" prop="Frequency">
					<el-input v-model.number="addForm.Frequency" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="时限(N月)" prop="Count">
					<el-input v-model.number="addForm.Count" auto-complete="off"></el-input>
				</el-form-item>	
				<el-form-item label="提醒次数" prop="Remind">
					<el-input v-model.number="addForm.Remind" auto-complete="off"></el-input>
				</el-form-item>						
						
				<el-form-item label="套餐金额" prop="Money">
					<el-input v-model="addForm.Money" auto-complete="off"></el-input>
				</el-form-item>	
				<!-- <el-form-item label="最终时间" prop="FinalTime">
					<el-date-picker v-model="addForm.FinalTime" type="date" placeholder="选择日期" > </el-date-picker>
				</el-form-item>	 -->
							
				<el-form-item label="备注">
					<el-input type="textarea" v-model="addForm.Remark"></el-input>
				</el-form-item>
				
			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>
		  <t-dialog :CardType="'0'" :msg="dialogValue" :show.sync="show"></t-dialog>
	</section>
</template>
<script>
import util from '../../common/js/util'
 import TDialog from './Zdialog';
import { editFrequencyCard,getFrequencyCardList,addFrequencyCard,removeFrequencyCard,OnlineSet} from '../../api/api';
export default {
	    components: {
            TDialog
        },
	data(){
		return {
			
			dialogValue:'',
            show: false,
			value1: true,
			total:0,
			page:1,
			listLoading:false,
			filters:{
              name:''
			},
			sels: [],//列表选中列

			FrequencyCard:[],


			 editFormVisible:false,
			 editLoading:false,
			 editFormRules:{},
			 editForm:{},
			 
			addFormVisible:false,
			addLoading: false,
			addFormRules:{
				Name: [
						{ required: true, message: '请输入套餐名称', trigger: 'blur' }
					],
				Frequency: [
						{ required: true, message: '请输入套餐次数'},
                        { type: 'number', message: '必须为数字值'}					],
				Count: [
						{ required: true, message: '请输入月份期限'},
                        { type: 'number', message: '必须为数字值'}
					],
				Remind: [
						{ required: true, message: '请输入提醒设置'},
                        { type: 'number', message: '必须为数字值'}
					],
					
			},
			addForm:{
				Name:'',
				Frequency:'',
				Remark:'',
				Money:0,
				FinalDate:'',
				Count:1,
				Remind:3

			}
		}
	},
	methods:{
		open (value) {
			this.dialogValue=value;
                this.show = true;
            },
		formatFinalTime: function (row, column) {
				return util.formatDate.format(new Date(row.FinalTime), 'yyyy-MM-dd');
			},
			formatState: function (row, column) {
				return row.State == 1 ? '停用' : '启用';
			},
			Change(State,index)
			{
				// row.IsShow=row.IsShow==false?true:false;		
				let para={
						Id:index,				
				}
              OnlineSet(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								    });
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});


			},
		    SwitchChange(row){
						// console.log(row.State);					
				 row.State=row.BoolState==true?1:0;			 								
				let para = {
					Id:row.Id,
					BoolState:row.BoolState,
					Frequency:row.Frequency,
					Money:row.Money,
					Name:row.Name,
					Remark:row.Remark,
					State:row.State,
					TenancyId:row.TenancyId,
                     FinalTime:row.FinalTime
				}
		     	editFrequencyCard(para).then((res)=>{
				
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
	            });
	      	},
		//删除
			handleDel(row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { Id:row.Id};
					// console.log(para);
					removeFrequencyCard(para).then((res) => {
                    //   console.log(res);
						this.listLoading = false;
						//NProgress.done();
						 if(res.data.Success==true)
						 {
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getFrequencyCard();

						 }else
						 {
							this.$message({
							message: res.data.Msg,
							type: 'error'
						      }); 
						 }
					});
				}).catch(() => {

				});
			},
	    	handleCurrentChange(val) {
				this.page = val;
				this.getFrequencyCard();
			},
		    selsChange: function (sels) {
				this.sels = sels;
			},
		//显示新增界面
			handleAdd: function () {
				this.addFormVisible = true;
				this.addForm = {
				Name:'',
				Frequency:'',
				Remark:'',
				Money:0,
				FinalTime:Date.now(),
				Count:1	,
				Remind:3				
				};},
	     	getFrequencyCard(){
			let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					Name:this.filters.name
				};
				this.listLoading = true;
				getFrequencyCardList(para).then((res)=>{
					this.total = res.data.TotleCount;
					this.FrequencyCard =res.data.Data;
					this.listLoading = false;
				})
				.catch(error=>{
                 alert('网络错误');
                });
		    },
		//新增
		addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						let remind="确认提交吗？";
						if(this.addForm.Count<2)
						{
							remind="未修改时限(N月)默认为(一)个月,确认提交吗？";
						}
						this.$confirm(remind, '提示', {}).then(() => {
							this.addLoading = true;
							let para= Object.assign({}, this.addForm);							
							para.FinalTime= (!para.FinalTime || para.FinalTime == '') ? '' : util.formatDate.format(new Date(para.FinalTime), 'yyyy-MM-dd');
							addFrequencyCard(para).then((res) => {							
								this.addLoading = false;
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								    });
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}
								this.$refs['addForm'].resetFields();
								this.addFormVisible = false;
								this.getFrequencyCard();
							}) .catch(error=>{
                            alert('系统错误');
                            });														
						});
					}
				});
			},
	},
		mounted() {
			this.getFrequencyCard();
		}
}
</script>



// WEBPACK FOOTER //
// FrequencyCard.vue?7c07b678